import { useEffect, useRef } from "react";
import { TypeAnimation } from "react-type-animation";

import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useContextHook } from "../../Context/ContextOPen";
import { heroImag } from "../../Context/Lists";
import { toScroll } from "../../Context/functions";
import {
  Col,
  ContactIcons,
  Container,
  MainButton,
  Row,
} from "../../components";
import { content } from "../../lang/useLang";

const Hero = () => {
  const { swiperIndex, direction } = useContextHook();

  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {}, {
      threshold: 0.5,
    });

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={heroRef}
      className="min-h-screen relative overflow-hidden transition-all duration-1000"
      style={{
        direction,
        // background: isVisible
        //   ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)"
        //   : "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
      }}
    >
      <br />
      <br />
      <br />
      {/* تأثيرات الخلفية */}
      <div className="absolute inset-0 overflow-hidden">
        {/* أشكال هندسية متحركة */}
        <div className="absolute top-1/4 -left-10 w-20 h-20 bg-cyan-500/10 rounded-full animate-pulse-glow"></div>
        <div
          className="absolute top-1/3 right-10 w-16 h-16 bg-purple-500/10 rounded-full animate-pulse-glow"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute bottom-1/4 left-1/4 w-12 h-12 bg-cyan-500/5 rounded-full animate-pulse-glow"
          style={{ animationDelay: "4s" }}
        ></div>
        <div
          className="absolute bottom-1/3 right-1/4 w-24 h-24 bg-purple-500/5 rounded-full animate-pulse-glow"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* خطوط متحركة */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent animate-shimmer"></div>
        <div
          className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-purple-500/20 to-transparent animate-shimmer"
          style={{ animationDelay: "1.5s" }}
        ></div>
      </div>

      <Container className="relative z-10">
        <Row className="items-center min-h-screen">
          {/* الصورة */}
          <Col md={6} className="flex justify-center items-center relative">
            <Swiper
              style={{ direction: "ltr" }}
              modules={[Pagination, Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              loop={true}
              className="w-full h-full"
            >
              {heroImag.map((e, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={e}
                    alt=""
                    className="w-full h-[40vh] object-cover rounded-xl"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>

          {/* النص الرئيسي */}
          <Col md={6} className="space-y-8 relative">
            {/* تأثير خلفي للنص */}
            <div className="absolute -inset-6 bg-gradient-to-r from-purple-500/5 to-cyan-500/5 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>

            <div
              className={`relative transition-all duration-1000 ${
                swiperIndex === 0 || !swiperIndex
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-10"
              }`}
            >
              {/* الترحيب */}
              <div
                className="text-4xl max-sm:text-2xl font-bold mb-4 text-white animate-fade-in-up"
                style={{ animationDelay: "200ms" }}
              >
                {content.WelcomeTo}
              </div>

              {/* العنوان المتحرك */}
              <div
                className="text-2xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-purple-300 animate-fade-in-up"
                style={{ animationDelay: "400ms" }}
              >
                {content.OurServices + " "}
                <div className="lg:hidden"></div>
                {content.services_1 && content.services_2 && (
                  <TypeAnimation
                    sequence={[
                      content.services_1,
                      1000,
                      content.services_2,
                      1000,
                      content.services_3,
                      1000,
                      content.services_4,
                      1000,
                    ]}
                    wrapper="span"
                    speed={60}
                    style={{
                      fontSize: "1em",
                      background: "linear-gradient(135deg, #67e8f9, #a855f7)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                    repeat={Infinity}
                  />
                )}
              </div>

              {/* الوصف */}
              {/* <p
                className="leading-7 text-lg mb-6 text-gray-200 animate-fade-in-up"
                style={{ animationDelay: "600ms" }}
              >
                {content.heroDescription}
              </p> */}

              {/* أيقونات التواصل */}
              <div
                className="animate-fade-in-up"
                style={{ animationDelay: "800ms" }}
              >
                <ContactIcons index={0} />
              </div>

              {/* الزر الرئيسي */}
              <div
                className="anav.scrollnimate-fade-in-up"
                style={{ animationDelay: "1000ms" }}
              >
                <MainButton
                  onClick={() => {
                    toScroll(6250);
                  }}
                  name={content.contact_us}
                  className="my-4 transform hover:scale-105 transition-transform duration-300"
                  index={0}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes orbital-1 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(50px, -30px) rotate(90deg);
          }
          50% {
            transform: translate(0, -60px) rotate(180deg);
          }
          75% {
            transform: translate(-50px, -30px) rotate(270deg);
          }
        }
        @keyframes orbital-2 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(-40px, 20px) rotate(-90deg);
          }
          50% {
            transform: translate(0, 40px) rotate(-180deg);
          }
          75% {
            transform: translate(40px, 20px) rotate(-270deg);
          }
        }
        @keyframes pulse-glow {
          0%,
          100% {
            opacity: 0.1;
            transform: scale(1);
          }
          50% {
            opacity: 0.3;
            transform: scale(1.1);
          }
        }
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes twinkle {
          0%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes spin-slow-reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-orbital-1 {
          animation: orbital-1 20s ease-in-out infinite;
        }
        .animate-orbital-2 {
          animation: orbital-2 25s ease-in-out infinite;
        }
        .animate-pulse-glow {
          animation: pulse-glow 8s ease-in-out infinite;
        }
        .animate-shimmer {
          animation: shimmer 3s ease-in-out infinite;
        }
        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
        .animate-spin-slow-reverse {
          animation: spin-slow-reverse 25s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Hero;
